var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{on:{"showNotification":_vm.notifyVue,"cotentLoading":_vm.cotentLoading}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }